import React, { useEffect } from 'react'
import PropTypes from 'prop-types';
import PopupLayout from 'components/PopupLayout';
import PopupTermCondRegister from 'components/PopupTermCondRegister';
import { useState } from 'react';
import MsgError from 'components/MsgError';

const TermPolCheckbox = ({textId="",onCheckboxClick,value,setValue,showToolip=false,disableCheck=false }) => {

  const [showTermConditions,setShowTermConditions]=useState(false);
  const [isChecked, setIsChecked] = useState(value);


  const contentCheckBox = [{
    "value": "terminos",
    "title": "TÉRMINOS Y CONDICIONES DE USO DE LA WEB DE CUPONES", 
    "text": "He leido y acepto los Términos y Condiciones"
  },
  {
    "value": "politica",
    "title": "POLÍTICA DE PRIVACIDAD", 
    "text": "He leído y acepto que mi información se utilizará conforme a las Politícas de Privacidad y seguridad"
  },
  {
    "value": "data-protection",
    "title": "PROTECCION DE DATOS", 
    "text": "Acepto recibir comunicaciones informativas y/o promocionales relacionadas a los diversos productos y servicios que se comercializan en Wong"
  },
  {
  "value": "",
  "title": "TITLE DEFAULT", 
  "text": "text default"
  },
  {
    "value": "legal-others",
    "title": "DATA ADICIONALES", 
    "text": "Autorizo el uso de mis datos para finalidades adicionales."
  }
  ];
function getText( textElement){
  let value = contentCheckBox.find(e => e.value===textElement).text;
  
  return value;

}
function getTitle( textElement){
  return contentCheckBox.find(element => element.value===textElement).title;

}


    // let titleCheckbox="";
  const openTermConditions = () =>{
      //open popup band title end text de checkbox
 

      setShowTermConditions(!showTermConditions);
  }
  const handleChecked = e =>{

   // handlegetValueCheked(e); 
    //other
    setIsChecked(e.target.checked);
    setValue && setValue(e.target.checked); // Utiliza la función setValue para actualizar el estado
    onCheckboxClick && onCheckboxClick(e.target.checked);


  }
 


  useEffect(() => {
    // Si la prop 'value' cambia externamente, actualizar el estado del checkbox
    setIsChecked(value);
  }, [value]);
  return (
    <div  id="divc">
      
      <div className="form-group graystrong-on-hover">
                <label className="checkcontainer" >
                    <input  type="checkbox"  id={textId} checked={isChecked} onChange={handleChecked} required disabled={disableCheck}/>
                    <span className="checkmark "></span>
                    <label>
                    <u><a onClick={openTermConditions} id="popup">
                    {getText(textId)}
                    </a></u>
                    </label>                  
                </label> 
                
               
      </div>
      { showToolip && !isChecked &&
      <MsgError  msg="*Obligatorio"/>
      }
     
      { textId!=""&&
      <PopupLayout isShowwing={showTermConditions} showingCallback={openTermConditions}>
            <PopupTermCondRegister execActionConfirm={openTermConditions} titleText={getTitle(textId)} popupLegalText={textId} />
      </PopupLayout>
      }
    </div>
  )
}
TermPolCheckbox.propTypes = {
  textId: PropTypes.string,
  onCheckboxClick:PropTypes.func,
  value:PropTypes.bool,
  setValue:PropTypes.func,
  showToolip:PropTypes.bool,
  disableCheck:PropTypes.bool

  

  
  
};
export default TermPolCheckbox;
